import React, { useEffect, useRef, useState } from 'react';

const API_PREFIX = '';


const SECRET_KEY = 'buboes1is2Verynice3456';

export default function ApprovalPage() {
  const [pending, setPending] = useState([]);
  const [approved, setApproved] = useState([]);
  const [error, setError] = useState('');
  const audioRefs = useRef({});

  // confirm-delete modal state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmTarget, setConfirmTarget] = useState(null); // { id, song, artist }
const [editingId, setEditingId] = useState(null);
const [draft, setDraft] = useState({ song: '', artist: '', description: '', date: '' });
const [saving, setSaving] = useState(false);

const beginEdit = (item) => {
  setEditingId(item.id);
  setDraft({
    song: item.song || '',
    artist: item.artist || '',
    description: item.description || '',
    date: item.date || '' // keep ISO as-is
  });
};

const cancelEdit = () => {
  setEditingId(null);
  setDraft({ song: '', artist: '', date: '' });
};

const saveEdit = async (id) => {
  setSaving(true);
  try {
    const body = new URLSearchParams({
      id: String(id),
      key: SECRET_KEY,
      song: draft.song,
      artist: draft.artist,
      description: draft.description,
      date: draft.date
    });

    const res = await fetch(`${API_PREFIX}/api/update`, {
      method: 'POST',
      body
    });

    const data = await parseMaybeHtmlThenJson(res, '/api/update');
    if (!res.ok) throw new Error(data?.error || 'Update failed');

    cancelEdit();
    refreshAll();
  } finally {
    setSaving(false);
  }
};

// Optional: make date human-friendly in view mode
const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

  const parseMaybeHtmlThenJson = async (res, friendlyApiName) => {
    const text = await res.text();

    // If your server routes /api/* incorrectly, you’ll get React index.html back
    if (text.trim().toLowerCase().startsWith('<!doctype html>') || text.includes('<div id="root">')) {
      throw new Error(`API returned HTML (index.html) instead of JSON. ${friendlyApiName} is not reachable.`);
    }

    return JSON.parse(text);
  };

  const loadPending = async () => {
    try {
      const url = `${API_PREFIX}/api/pending?key=${encodeURIComponent(SECRET_KEY)}`;
      const res = await fetch(url);
      const data = await parseMaybeHtmlThenJson(res, '/api/pending');

      const list = Array.isArray(data) ? data : (Array.isArray(data.pending) ? data.pending : []);
      setPending(list);
    } catch (e) {
      console.error(e);
      setPending([]);
      throw e;
    }
  };

  const loadApproved = async () => {
    try {
      const url = `${API_PREFIX}/api/covers`;
      const res = await fetch(url);

      // /api/covers is public; still guard for HTML just in case routing breaks
      const data = await parseMaybeHtmlThenJson(res, '/api/covers');

      const list = Array.isArray(data) ? data : (Array.isArray(data.covers) ? data.covers : []);
      setApproved(list);
    } catch (e) {
      console.error(e);
      setApproved([]);
      throw e;
    }
  };

  const refreshAll = async () => {
    setError('');
    try {
      await Promise.all([loadPending(), loadApproved()]);
    } catch (e) {
      setError(e?.message || 'Failed to load approvals data.');
    }
  };

  useEffect(() => {
    refreshAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const approve = async (id) => {
    await fetch(`${API_PREFIX}/api/approve`, {
      method: 'POST',
      body: new URLSearchParams({ id, key: SECRET_KEY })
    });
    refreshAll();
  };

  // actual delete call (used for both pending + approved)
  const deleteById = async (id) => {
    await fetch(`${API_PREFIX}/api/reject`, {
      method: 'POST',
      body: new URLSearchParams({ id, key: SECRET_KEY })
    });
    refreshAll();
  };

  const askDelete = (item) => {
    setConfirmTarget({ id: item.id, song: item.song, artist: item.artist });
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!confirmTarget?.id) return;
    const id = confirmTarget.id;

    setConfirmOpen(false);
    setConfirmTarget(null);

    await deleteById(id);
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setConfirmTarget(null);
  };

const Card = ({ item, actions }) => {
  const isEditing = editingId === item.id;

  return (
    <div style={{ border: '1px solid #555', marginBottom: 16, padding: 16 }}>
      {!isEditing ? (
        <>
          <h3 style={{ margin: 0 }}>{item.song}</h3>
          <p style={{ marginTop: 6 }}>
            by {item.artist} {item.date ? <>• <span style={{ opacity: 0.85 }}>{formatDate(item.date)}</span></> : null}
          </p>
        </>
      ) : (
        <>
          <div style={{ display: 'grid', gap: 8 }}>
            <label>
              <div style={{ fontSize: 12, opacity: 0.85 }}>Song name</div>
              <input
                value={draft.song}
                onChange={(e) => setDraft(d => ({ ...d, song: e.target.value }))}
                style={{ width: '100%' }}
              />
            </label>

            <label>
              <div style={{ fontSize: 12, opacity: 0.85 }}>Band / Artist</div>
              <input
                value={draft.artist}
                onChange={(e) => setDraft(d => ({ ...d, artist: e.target.value }))}
                style={{ width: '100%' }}
              />
            </label>

            <label>
              <div style={{ fontSize: 12, opacity: 0.85 }}>Date (ISO or leave alone)</div>
              <input
                value={draft.date}
                onChange={(e) => setDraft(d => ({ ...d, date: e.target.value }))}
                placeholder="2026-01-03T21:15:00.000Z"
                style={{ width: '100%' }}
              />
            </label>
            <label>
              <div style={{ fontSize: 12, opacity: 0.85 }}>Description</div>
              <textarea
                value={draft.description}
                onChange={(e) => setDraft(d => ({ ...d, description: e.target.value }))}
                style={{ width: '100%' }}
                rows={4}
              />
            </label>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={cancelEdit} disabled={saving}>Cancel</button>
              <button onClick={() => saveEdit(item.id)} disabled={saving}>
                {saving ? 'Saving…' : 'Save'}
              </button>
            </div>
          </div>
        </>
      )}

      <audio
        controls
        src={item.audioUrl}
        ref={el => (audioRefs.current[item.id] = el)}
        style={{ width: '100%', marginTop: 10 }}
      />

      <div style={{ marginTop: 12 }}>
        {!isEditing && (
          <button onClick={() => beginEdit(item)} style={{ marginRight: 8 }}>
            ✏️ Edit
          </button>
        )}
        {actions}
      </div>
    </div>
  );
};


  return (
    <div style={{ padding: 24 }}>
      <h1>Pending Submissions</h1>

      {error && (
        <div style={{ background: '#F55', border: '1px solid #a55', padding: 12, marginBottom: 12 }}>
          <b>Error:</b> {error}
        </div>
      )}

      {/* Confirm modal */}
      {confirmOpen && (
        <div
          onClick={cancelDelete}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            zIndex: 9999
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(520px, 100%)',
              background: '#111',
              border: '1px solid #555',
              borderRadius: 10,
              padding: 18,
              color: '#f5f5f5'
            }}
          >
            <h2 style={{ marginTop: 0 }}>Delete this submission?</h2>
            <p style={{ marginBottom: 16 }}>
              This will remove it from the database and attempt to delete the audio file.
              <br />
              <b>{confirmTarget?.song}</b> — {confirmTarget?.artist}
            </p>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={cancelDelete}>Cancel</button>
              <button onClick={confirmDelete} style={{ background: '#b00020', color: 'white' }}>
                Yes, delete
              </button>
            </div>
          </div>
        </div>
      )}

      {pending.length === 0 && !error && <p>No pending submissions.</p>}

      {pending.map(p => (
        <Card
          key={p.id}
          item={p}
          actions={
            <>
              <button onClick={() => approve(p.id)}>✅ Approve</button>
              <button onClick={() => askDelete(p)} style={{ marginLeft: 8 }}>
                🗑️ Delete
              </button>
            </>
          }
        />
      ))}

      <hr style={{ margin: '28px 0', borderColor: '#333' }} />

      <h1>Approved / Manage</h1>
      <p style={{ opacity: 0.85, marginTop: 6 }}>
        These are already on the public site (from <code>/api/covers</code>). You can delete them here.
      </p>

      {approved.length === 0 && !error && <p>No approved songs found.</p>}

      {approved.map(a => (
        <Card
          key={a.id}
          item={a}
          actions={
            <>
              <button onClick={() => askDelete(a)}>
                🗑️ Delete approved
              </button>
            </>
          }
        />
      ))}
    </div>
  );
}
